/**
 * 时间轴标签密度计算 composable
 */

/**
 * 根据屏幕宽度获取允许显示的小时列表
 * @param {number} screenWidth
 * @returns {string[]}
 */
export function getAllowedHours(screenWidth) {
  if (screenWidth <= 576) return ['00', '06', '12', '18'];
  if (screenWidth <= 768) return ['00', '03', '06', '09', '12', '15', '18', '21'];
  return ['02', '04', '06', '08', '10', '12', '14', '16', '18', '20', '22'];
}

/**
 * 根据屏幕宽度获取日期标签显示间隔
 * @param {number} screenWidth
 * @returns {number}
 */
export function getDateInterval(screenWidth) {
  if (screenWidth <= 576) return 3;
  if (screenWidth <= 768) return 2;
  return 1;
}

/**
 * 计算主时间轴的 marks 对象
 * @param {Array} data - 数据列表
 * @param {number} screenWidth - 屏幕宽度
 * @returns {object} el-slider 的 marks 配置
 */
export function computeMainMarks(data, screenWidth) {
  const now = new Date();
  const day = now.getDate() + 2;
  const allowedHours = getAllowedHours(screenWidth);
  const dateInterval = getDateInterval(screenWidth);
  let list = [];
  let objc = {};
  let dateCount = 0;

  data.forEach((item, index) => {
    const part1 = item.date.slice(5, 7);
    const part2 = item.date.slice(8, 10);
    const part3 = item.date.slice(11, 13);
    const part4 = item.date.slice(14, 16);
    const foundIndex = list.findIndex((f) => f === part2);

    if (
      foundIndex === -1 ||
      (data[0].fileDesc.slice(3, 5) - 0 + 4 <= part1 - 0 && part3 === "14")
    ) {
      if (part3 === "23" || part3 === "22") {
        objc[index] = {
          style: { color: "#fff", top: "-60px" },
          label: "",
        };
      } else {
        dateCount++;
        const showDateLabel = dateCount % dateInterval === 1 || dateInterval === 1;
        objc[index] = {
          style: { color: "#fff", background: "#0B0F3960", top: "-60px" },
          label: showDateLabel ? part2 + "日" : "",
        };
      }
    } else if (allowedHours.includes(part3) && part2 - 0 <= day) {
      objc[index] = {
        style: { color: "#fff", top: "-5px" },
        label: part3,
      };
    } else if (allowedHours.includes(part3) && part3 != 14) {
      objc[index] = {
        style: { color: "#fff", top: "-5px" },
        label: part3,
      };
    } else {
      objc[index] = {
        style: { color: "#fff", top: "-5px" },
        label: "",
      };
    }

    if (foundIndex === -1) {
      list.push(part2);
    } else {
      if (list.findIndex((f) => f === part4) === -1) {
        list.push(part4);
      }
    }
  });

  return objc;
}

/**
 * 计算弹窗时间轴的 marks 对象
 * @param {Array} data - 数据列表
 * @param {number} screenWidth - 屏幕宽度
 * @param {string} textName - 当前功能名称
 * @returns {object} el-slider 的 marks 配置
 */
export function computeDialogMarks(data, screenWidth, textName) {
  const nnum = Math.ceil(data.length / 30);
  const allowedHours = getAllowedHours(screenWidth);
  const dateInterval = getDateInterval(screenWidth);
  let list = [];
  let objc = {};
  let dateCount = 0;

  data.forEach((item, index) => {
    const part1 = item.date.slice(5, 7);
    const part2 = item.date.slice(8, 10);
    const part3 = item.date.slice(11, 13);
    const part4 = item.date.slice(14, 16);
    const part5 = item.date.slice(13, 16);
    const foundIndex = list.findIndex((f) => f === part2);

    if (textName === "实况云图" || textName === "雷达拼图") {
      if (index % nnum === 0) {
        objc[index] = {
          style: { color: "#000", top: "-5px" },
          label: part3 + part5,
        };
      }
    } else {
      if (
        foundIndex === -1 ||
        (data[0].fileDesc.slice(3, 5) - 0 + 4 <= part1 - 0 && part3 === "14")
      ) {
        if (part3 === "14") {
          objc[index] = {
            style: { color: "#fff", top: "-40px" },
            label: "",
          };
        } else {
          dateCount++;
          const showDateLabel = dateCount % dateInterval === 1 || dateInterval === 1;
          objc[index] = {
            style: { color: "#fff", background: "#0B0F3960", top: "-40px" },
            label: showDateLabel ? part2 + "日" : "",
          };
        }
      } else {
        if (allowedHours.includes(part3)) {
          objc[index] = {
            style: { color: "#000", top: "-5px" },
            label: part3,
          };
        } else {
          objc[index] = {
            style: { color: "#000", top: "-5px" },
            label: "",
          };
        }
      }
    }

    if (foundIndex === -1) {
      list.push(part2);
    } else {
      if (list.findIndex((f) => f === part4) === -1) {
        list.push(part4);
      }
    }
  });

  return objc;
}

/**
 * 查找当前时间对应的时间轴索引
 * @param {Array} data - 数据列表
 * @returns {number} 对应索引
 */
export function findCurrentTimeIndex(data) {
  const now = Date.now();
  for (let i = 0; i < data.length; i++) {
    const item = data[i];
    const dateString =
      item.date.slice(0, 4) + "-" +
      item.date.slice(5, 7) + "-" +
      item.date.slice(8, 10) + "T" +
      item.date.slice(11, 13) + ":00:00";
    const timestamp = new Date(dateString).getTime();
    if (now <= timestamp) {
      return Math.max(0, i - 1);
    }
  }
  return data.length - 1;
}
